export const hasValidNpiFormat = npi => typeof npi === 'string' && /^[12]\d{9}$/.test(npi);

export const hasValidNpiChecksum = npi => {
  if (typeof npi !== 'string' || !/^\d{10}$/.test(npi)) {
    return false;
  }

  const prefixedNpi = `80840${npi}`;
  const sum = [...prefixedNpi].reverse().reduce((total, value, index) => {
    let digit = Number(value);
    if (index % 2 === 1) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    return total + digit;
  }, 0);

  return sum % 10 === 0;
};

const isValidNpi = npi => hasValidNpiFormat(npi) && hasValidNpiChecksum(npi);

export default isValidNpi;
